import React, { useMemo } from "react";
import ReactECharts from "echarts-for-react";

const NightingaleChart = ({ title = "", height = 500, data = [] }) => {
  const total = useMemo(
    () => data.reduce((sum, d) => sum + (Number(d.value) || 0), 0),
    [data]
  );

  const option = useMemo(
    () => ({
      tooltip: {
        trigger: "item",
        formatter: "{b}: {c} ({d}%)",
      },

      legend: {
        bottom: -5,
        left: "center",
      },

      graphic: {
        type: "group",
        left: "center",
        top: "center",
        children: [
          {
            type: "text",
            top: -10,
            style: {
              text: "Total Cases",
              fill: "#666363ff",
              fontSize: 14,
              textAlign: "center",
            },
          },
          {
            type: "text",
            top: 12,
            style: {
              text: total.toLocaleString(),
              fill: "#333",
              fontSize: 26,
              fontWeight: 700,
              textAlign: "center",
            },
          },
        ],
      },

      series: [
        {
          name: title,
          type: "pie",
          roseType: "area",
          radius: ["30%", "65%"],
          center: ["50%", "50%"],
          itemStyle: {
            borderRadius: 8,
          },
          label: {
            show: true,
            formatter: "{b}\n{c}",
            fontSize: 13,
            fontWeight: "bold",
          },
          emphasis: {
            scale: true,
            scaleSize: 10,
          },
          data,
        },
      ],
    }),
    [title, data, total]
  );

  return (
    <div>
      <div className="row">
        <h5 className="bg-dark text-white">{title}</h5>
      </div>

      <ReactECharts
        option={option}
        style={{ height, width: "100%" }}
        notMerge
        lazyUpdate
      />
    </div>
  );
};

export default NightingaleChart;
